import { client } from "api";
import { OrderSerial } from "models/OrderSerial";

export type AssignOrderSerialRequest = {
  checklistId: string;
  id: string;
  serial: string | null;
  ip: string | null;
  macAddressWired: string | null;
  macAddressWifi: string | null;
  ethernetPort: string | null;
  theftMarking: string | null;
  assetNo: string | null;
  userName: string | null;
  password: string | null;
  firmware: string | null;
  other: string | null;
  doa: boolean;
};

export type AssignOrderSerialResponse = OrderSerial;

export const assignOrderSerial = ({ checklistId, ...data }: AssignOrderSerialRequest) =>
  client
    .post<AssignOrderSerialResponse>(`/checklist/add-serial/${checklistId}`, data)
    .then((res) => res.data);
